import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from '../../components/TopBar'
import Footer from '../../components/Footer'
import { Fade, Slide } from "react-awesome-reveal";
import { isMobileDevice } from "../../utils";
import { useNavigate } from "react-router";
import More from "./components/more"

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className="w-[1100px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4"> 報導專區</div>
        </div>
        <div className="text-center text-[#181512] text-[46px] font-bold pb-[150px] h5:pb-[20px]">報導專區</div>
      </div>

      <div className="w-[1200px] mx-auto pb-[75px] h5:block h5:w-full">
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木×HANSEN亮相台北時裝週　展現東方敘事力</div>
                <a href="https://www.ftvnews.com.tw/news/detail/2025401W0305?_ga=2.92454878.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon1.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon2.jpg")}
                className="w-full max-h-[361px] relative right-[16px] object-cover h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木跨界聯名鄭子宏 傳遞品牌自然美學生命力</div>
                <a href="https://www.ctee.com.tw/news/20250326701635-431207?_ga=2.16546677.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>

        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木挑戰家具行業常規 主打永續使用 實木家具全台熱賣</div>
                <a href="https://tw.stock.yahoo.com/news/%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8%E6%8C%91%E6%88%B0%E5%AE%B6%E5%85%B7%E8%A1%8C%E6%A5%AD%E5%B8%B8%E8%A6%8F-%E4%B8%BB%E6%89%93%E6%B0%B8%E7%BA%8C%E4%BD%BF%E7%94%A8-%E5%AF%A6%E6%9C%A8%E5%AE%B6%E5%85%B7%E5%85%A8%E5%8F%B0%E7%86%B1%E8%B3%A3-032804546.html?_ga=2.260742222.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon3.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon4.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木50週年限定登場！再進化超幻色彩潮色布套不容錯過！</div>
                <a href="https://tw.news.yahoo.com/news/%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A850%E9%80%B1%E5%B9%B4%E9%99%90%E5%AE%9A%E7%99%BB%E5%A0%B4-%E5%86%8D%E9%80%B2%E5%8C%96%E8%B6%85%E5%B9%BB%E8%89%B2%E5%BD%A9%E6%BD%AE%E8%89%B2%E5%B8%83%E5%A5%97%E4%B8%8D%E5%AE%B9%E9%8C%AF%E9%81%8E-051429765.html?_ga=2.192511849.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>

        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">母親節讓媽媽最舒適! 用德國法蘭克名床表達對媽媽的感激</div>
                <a href="https://tw.news.yahoo.com/news/%E6%AF%8D%E8%A6%AA%E7%AF%80%E8%AE%93%E5%AA%BD%E5%AA%BD%E6%9C%80%E8%88%92%E9%81%A9-%E7%94%A8%E5%BE%B7%E5%9C%8B%E6%B3%95%E8%98%AD%E5%85%8B%E5%90%8D%E5%BA%8A%E8%A1%A8%E9%81%94%E5%B0%8D%E5%AA%BD%E5%AA%BD%E7%9A%84%E6%84%9F%E6%BF%80-031446407.html?_ga=2.260267982.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon5.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon6.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">台灣人最喜歡到這些地方買家具 詩肯柚木 IKEA 宜得利 你選誰？</div>
                <a href="https://tw.news.yahoo.com/news/%E5%8F%B0%E7%81%A3%E4%BA%BA%E6%9C%80%E5%96%9C%E6%AD%A1%E5%88%B0%E9%80%99%E4%BA%9B%E5%9C%B0%E6%96%B9%E8%B2%B7%E5%AE%B6%E5%85%B7-%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8-ikea-%E5%AE%9C%E5%BE%97%E5%88%A9-%E4%BD%A0%E9%81%B8%E8%AA%B0-045500781.html?_ga=2.200520429.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">家具店的秘密武器！居民直呼「這才是社區活動該有的樣子」</div>
                <a href="https://tw.news.yahoo.com/news/%E5%AE%B6%E5%85%B7%E5%BA%97%E7%9A%84%E7%A7%98%E5%AF%86%E6%AD%A6%E5%99%A8-%E5%B1%85%E6%B0%91%E7%9B%B4%E5%91%BC-%E9%80%99%E6%89%8D%E6%98%AF%E7%A4%BE%E5%8D%80%E6%B4%BB%E5%8B%95%E8%A9%B2%E6%9C%89%E7%9A%84%E6%A8%A3%E5%AD%90-043900924.html?_ga=2.264805452.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">
                    – 閱讀全文 –
                  </div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon7.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon8.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">高溫不減愛心熱情! 詩肯柚木舉辦大型捐血活動 傳遞愛與關懷</div>
                <a href="https://tw.news.yahoo.com/news/%E9%AB%98%E6%BA%AB%E4%B8%8D%E6%B8%9B%E6%84%9B%E5%BF%83%E7%86%B1%E6%83%85-%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8%E8%88%89%E8%BE%A6%E5%A4%A7%E5%9E%8B%E6%8D%90%E8%A1%80%E6%B4%BB%E5%8B%95-%E5%82%B3%E9%81%9E%E6%84%9B%E8%88%87%E9%97%9C%E6%87%B7-020300962.html?_ga=2.20094971.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯居家推出全牛皮沙發優惠 打造時尚舒適家居生活</div>
                <a href="https://www.ctee.com.tw/news/20240802701662-431207?utm=LINE_share_btn&_ga=2.95656927.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon9.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon10.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">家具界的大驚喜！詩肯柚木餐桌椅組好市多限量上架 不搶真的會後悔！</div>
                <a href="https://tw.news.yahoo.com/news/%E5%AE%B6%E5%85%B7%E7%95%8C%E7%9A%84%E5%A4%A7%E9%A9%9A%E5%96%9C-%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8%E9%A4%90%E6%A1%8C%E6%A4%85%E7%B5%84%E5%A5%BD%E5%B8%82%E5%A4%9A%E9%99%90%E9%87%8F%E4%B8%8A%E6%9E%B6-%E4%B8%8D%E6%90%B6%E7%9C%9F%E7%9A%84%E6%9C%83%E5%BE%8C%E6%82%94-030700298.html?_ga=2.92978142.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">低調搶購「詩肯設計款家具」 門市一上架暨售罄</div>
                <a href="https://tw.news.yahoo.com/news/%E8%A2%AB%E4%BD%8E%E8%AA%BF%E6%90%B6%E8%B3%BC-%E8%A9%A9%E8%82%AF%E8%A8%AD%E8%A8%88%E6%AC%BE%E5%AE%B6%E5%85%B7-%E9%96%80%E5%B8%82-%E4%B8%8A%E6%9E%B6%E4%BB%A4%E6%B6%88%E8%B2%BB%E8%80%85%E9%A9%9A%E8%89%B7-1%E9%80%B1%E9%8A%B7%E5%94%AE-045600595.html?_ga=2.92509022.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon11.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon12.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">24 人追蹤追蹤 新加坡設計詩肯柚木 GOLDEN JUBILEE50週年紀念床墊</div>
                <a href="https://tw.news.yahoo.com/news/%E6%96%B0%E5%8A%A0%E5%9D%A1%E8%A8%AD%E8%A8%88%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8-golden-jubilee50%E9%80%B1%E5%B9%B4%E7%B4%80%E5%BF%B5%E5%BA%8A%E5%A2%8A-070844405.html?_ga=2.50050917.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
        <div className="flex relative h5:block h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[10%] mt-[75px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px] h5:mt-0">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">重塑北歐靈魂 美感極致 演繹詩肯柚木丹麥風家具系列秋季新品登場</div>
                <a href="https://tw.news.yahoo.com/news/%E9%87%8D%E5%A1%91%E5%8C%97%E6%AD%90%E9%9D%88%E9%AD%82-%E7%BE%8E%E6%84%9F%E6%A5%B5%E8%87%B4-%E6%BC%94%E7%B9%B9%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8%E4%B8%B9%E9%BA%A5%E9%A2%A8%E5%AE%B6%E5%85%B7%E7%B3%BB%E5%88%97%E7%A7%8B%E5%AD%A3%E6%96%B0%E5%93%81%E7%99%BB%E5%A0%B4-045818488.html?_ga=2.92967902.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pt-0 h5:relative h5:top-[-30px]">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon13.jpg")}
                className="w-full relative h5:left-[-18px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:block"></div>
        </div>
        <div className="flex relative h5:flex-col h5:ml-[26px] h5:mr-[6px]">
          <div className="p-[3px] rounded-full absolute top-[130px] left-[50%] translate-x-[-120%] z-10
          h5:top-[80px] h5:left-[10px] 
          "
            style={{
              border: '1px solid #6d6e71'
            }}>
            <div className="w-[6px] h-[6px] bg-[#6d6e71] rounded-full"></div>
          </div>
          <div className="flex-1 pt-[75px] h5:pt-[0px] h5:pr-16 h5:order-2">
            < Slide triggerOnce >
              <img src={require("../../assets/image/video/news/icon14.jpg")}
                className="w-full relative right-[16px] h5:left-[0px] h5:top-[-50px]"
                alt="" />
            </Slide>
          </div>
          <div className="w-[1px] bg-[#0003] relative pt-[75px] z-10 h5:hidden"></div>
          <div className="flex-1 pt-[75px] pl-[20px] h5:pl-[0px] h5:pt-0 h5:relative h5:order-1 h5:top-[-30px]">
            < Slide triggerOnce >
              <div className="bg-[#f6f5f1] px-[137px] py-[75px] relative left-[-10%] mt-[60px]
            h5:left-[-10px] h5:px-[37px] h5:pt-[30px] h5:pb-[50px]">
                <div className="text-[#181512] text-[40px] font-bold">-</div>
                <div className="text-[#181512] text-[24px] font-bold">詩肯柚木民生店聖誕好時光 從家具到社區三十年故事</div>
                <a href="https://tw.news.yahoo.com/news/%E8%A9%A9%E8%82%AF%E6%9F%9A%E6%9C%A8%E6%B0%91%E7%94%9F%E5%BA%97%E8%81%96%E8%AA%95%E5%A5%BD%E6%99%82%E5%85%89-%E5%BE%9E%E5%AE%B6%E5%85%B7%E5%88%B0%E7%A4%BE%E5%8D%80%E4%B8%89%E5%8D%81%E5%B9%B4%E6%95%85%E4%BA%8B-031701349.html?_ga=2.200521453.215742908.1767082552-1404405351.1766565616" target="_blank" rel="noopener noreferrer">
                  <div className="text-[#595959] text-[18px] mt-[30px]">– 閱讀全文 –</div>
                </a>
              </div>
            </Slide>
          </div>
          <div className="w-[1px] absolute top-0 left-0 bottom-0 bg-[#0003] hidden h5:z-10 h5:block"></div>
        </div>
      </div>


      <Footer />
    </div>
  );
};

export default ComponentName;
